import React, { useContext, useEffect, useState } from 'react';
import styles from './Header.module.css';
import UserName from '../../../components/common/user/UserName';
import UserAvatar from '../../../components/common/user/UserAvatar';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../components/context/AppContextProvider';

const Header = () => {
    const [showDropdown, setShowDropDown] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(false);
    const navigate = useNavigate();
    const { userInfo } = useContext(AppContext);

    // Listen for profile update events
    useEffect(() => {
        const handleUpdateStart = () => {
            setIsImageLoading(true);
        };

        window.addEventListener('profileUpdateStart', handleUpdateStart);

        return () => {
            window.removeEventListener('profileUpdateStart', handleUpdateStart);
        };
    }, []);

    // Handler for when new avatar image loads
    const handleAvatarImageLoad = () => {
        setIsImageLoading(false);
    };

    return (
        <div className={styles.header}>
            {/* <div></div> */}
            <div className={styles.userBox}>
                <div className={styles.support}>
                    <span
                        onClick={() =>
                            window.open(
                                'https://sites.google.com/tourwithpineapple.com/pineapplehelpcenter/home',
                                '__blank',
                                'noopener,noreferrer',
                            )
                        }>
                        Support
                    </span>
                </div>

                <div className={styles.user}>

                    <div className={styles.userName}>
                        <UserName />
                    </div>
                    <div className={styles.userAvatar}>
                        <UserAvatar
                            showDropdown={showDropdown}
                            setShowDropDown={setShowDropDown}
                            photoURL={userInfo?.photo_url || ''}
                            isLoading={isImageLoading}
                            onImageLoad={handleAvatarImageLoad}
                        />
                        {showDropdown && <div className={styles.backDrop} onClick={() => setShowDropDown(false)}></div>}
                        <div className={`${styles.dropdown} ${showDropdown ? styles.show : ''}`}>
                            <div className={styles.list} >
                                <div className={styles.item} onClick={() => {
                                    setShowDropDown(false)
                                    navigate('/profile');
                                }}>
                                    <span>My profile</span>
                                </div>

                                <div className={styles.item} onClick={() => {
                                    setShowDropDown(false)
                                    navigate('/locations');
                                }}>
                                    <span>Properties</span>
                                </div>

                                <div className={styles.item} onClick={() => {
                                    setShowDropDown(false)
                                    navigate('/change-password');
                                }}>
                                    <span>Change password</span>
                                </div>

                                {/* <LogoutButton /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
